// Generated by DesignToCode

import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-mini-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mini-card.html',
})
export class MiniCard {
  // Inputs
  public size = input<string>('small');
  public logo = input<string>('angular.png');
  public altText = computed(() =>
    this.logo()
      .replace(/\.[^.]+$/, '')
      .toLowerCase(),
  );

  public containerClasses = computed(() => {
    const base = [
      'flex',
      'flex-col',
      'flex-nowrap',
      'items-center',
      'justify-center',
      'bg-[#EEF4FD]',
      'pl-8',
      'pr-8',
      'rounded-lg',
      'border',
      'border-[#C6C6C6]',
      'w-full',
      'shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]',
    ];

    if (this.size() === 'small') {
      base.push('pt-[9px]', 'pb-[9px]', 'h-[48px]');
    } else if (this.size() === 'large') {
      base.push('pt-4', 'pb-4', 'h-[62px]');
    }

    return base.join(' ');
  });
}
